import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider, { Settings as SlickCarouselSettings } from "react-slick";

type SlickCarouselProps = SlickCarouselSettings & {
  children: React.ReactNode;
};

const SlickCarousel = ({ children, ...settings }: SlickCarouselProps) => {
  return <Slider {...settings}>{children}</Slider>;
};

export default SlickCarousel;
